// extracted by mini-css-extract-plugin
module.exports = {"buttonContainer":"UploadButton_buttonContainer__NF9wy","button":"UploadButton_button___C3ow","buttonText":"UploadButton_buttonText__26JuG","icon":"UploadButton_icon__366b1"};